import { render } from "./App.vue?vue&type=template&id=011d22b1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=011d22b1&lang=css"

import exportComponent from "/Users/morris.lin/Self/project/vue-rick-and-morty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__